const env = {
  BACKEND_API_URL:
    process.env.REACT_APP_BACKEND_API_URL || "http://localhost:1337/api/",
};

export default env;
